import type { PropertyOption } from "../types";
import { OpcionCreate, OpcionEdit } from "./OpcionForm";
import { OpcionList } from "./OpcionList";
import { OpcionShow } from "./OpcionShow";

/**
 * Almikia Epic EC (TASK-030): `property_options` resource ("Opciones"). No
 * delete route and no bulk actions: an option is withdrawn (status
 * 'retirada'), never deleted. Access is gated by `canAccess`.
 */
export default {
  list: OpcionList,
  show: OpcionShow,
  create: OpcionCreate,
  edit: OpcionEdit,
  recordRepresentation: (record: PropertyOption) => record.address,
};
